// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type Props = {
    width?: number;
}

export default (props: Props) => (
    <svg
        width={props.width?.toString() || '210'}
        height='200'
        viewBox='0 0 210 200'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <ellipse
            cx='119'
            cy='156.5'
            rx='91'
            ry='5.5'
            fill='black'
            fillOpacity='0.08'
        />
        <rect
            x='63.2988'
            y='44.1489'
            width='72.8724'
            height='111.702'
            rx='8'
            fill='#FFBC1F'
        />
        <rect
            x='29.2559'
            y='82.9785'
            width='140.957'
            height='72.8723'
            rx='8'
            fill='#CC8F00'
        />
        <path
            d='M136.171 47.1506V153.381C135.99 155.198 135.369 156.199 134.295 156.383H65.4458C64.1915 156.199 63.4796 155.198 63.2988 153.381V47.1506C63.4796 45.3335 64.1915 44.3329 65.4458 44.1489H134.295C135.369 44.3329 135.99 45.3335 136.171 47.1506Z'
            fill='#FFBC1F'
        />
        <path
            d='M113.842 127.686H85.9102V156.372H113.842V127.686Z'
            fill='#E8E9ED'
        />
        <rect
            x='61.1699'
            y='44.1489'
            width='77.1277'
            height='7.4468'
            rx='3'
            fill='#1E325C'
        />
        <rect
            x='82.9785'
            y='123.936'
            width='33.5106'
            height='7.4468'
            rx='3'
            fill='#1E325C'
        />
        <rect
            x='98.9375'
            y='130.851'
            width='2.12766'
            height='25.5319'
            fill='#1E325C'
        />
        <rect
            x='35.6387'
            y='95.7446'
            width='8.51064'
            height='16.4894'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='69.1504'
            y='58.5107'
            width='9.57447'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='106.383'
            y='58.5107'
            width='9.57447'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='69.1504'
            y='84.0425'
            width='9.57447'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='69.1504'
            y='109.574'
            width='9.57447'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='69.1504'
            y='123.936'
            width='9.57447'
            height='9.57446'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='69.1504'
            y='138.298'
            width='9.57447'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='106.383'
            y='84.0425'
            width='9.57447'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='106.383'
            y='109.574'
            width='9.57447'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='82.9785'
            y='58.5107'
            width='9.57448'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='120.213'
            y='58.5107'
            width='9.57446'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='82.9785'
            y='84.0425'
            width='9.57448'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='82.9785'
            y='109.574'
            width='9.57448'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='120.213'
            y='84.0425'
            width='9.57446'
            height='20.2128'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='120.213'
            y='109.574'
            width='9.57446'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='120.213'
            y='123.936'
            width='9.57446'
            height='9.57446'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='120.213'
            y='138.298'
            width='9.57446'
            height='9.57448'
            rx='3'
            fill='#CC8F00'
        />
        <rect
            x='142.555'
            y='95.7446'
            width='8.51062'
            height='16.4894'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='35.6387'
            y='118.617'
            width='8.51064'
            height='8.51064'
            rx='3'

            fill='#7A5600'
        />
        <rect
            x='142.555'
            y='118.617'
            width='8.51062'
            height='8.51064'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='35.6387'
            y='134.042'
            width='8.51064'
            height='8.51065'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='142.555'
            y='134.042'
            width='8.51062'
            height='8.51065'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='48.4043'
            y='95.7446'
            width='8.51064'
            height='16.4894'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='155.32'
            y='95.7446'
            width='8.51065'
            height='16.4894'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='48.4043'
            y='118.617'
            width='8.51064'
            height='8.51064'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='155.32'
            y='118.617'
            width='8.51065'
            height='8.51064'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='48.4043'
            y='134.042'
            width='8.51064'
            height='8.51065'
            rx='3'
            fill='#7A5600'
        />
        <rect
            x='155.32'
            y='134.042'
            width='8.51065'
            height='8.51065'
            rx='3'
            fill='#7A5600'
        />
    </svg>
);
